



















import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { ApiV2Service } from '../services/api.base.service';
// @ts-ignore
// tslint:disable-next-line
const QuickSightEmbedding = require('amazon-quicksight-embedding-sdk');

@Component({})
export default class QuicksightDashboard extends Vue {

  @Prop({default: '100%'}) private height!: string;
  @Prop({default: '100%'}) private width!: string;
  @Prop() private dashboardId!: string;
  private thirdPartyCookiesSupported: boolean = true;

  private async mounted() {

    window.addEventListener('message', this.checkCookies.bind(this), false);

    const { url } = await ApiV2Service.get<{ url: string }>(`reporting/dashboardUrl?dashboardId=${this.dashboardId}`);

    const options = {
        url,
        container: '#dashboardContainer',
    };
    const dashboard = QuickSightEmbedding.embedDashboard(options);
  }

  private checkCookies(evt: any) {
    if (evt.data === 'MM:3PCunsupported') {
      this.thirdPartyCookiesSupported = false;
    }
  }

  private overrideCookies() {
    this.thirdPartyCookiesSupported = true;
  }
}
